interface EmailQuoteVisibilityInput {
  body?: string | null;
  showSignature?: boolean;
  subject?: string | null;
}

export const isForwardedEmail = ({ body, subject }: EmailQuoteVisibilityInput): boolean => {
  const emailSubject = subject ?? '';
  const emailBody = body ?? '';

  // Treat forwarded emails as current content even when the provider wraps them
  // in `.gmail_quote`: Outlook/Gmail subjects use FW/Fwd, Gmail inserts a
  // dashed "Forwarded message" divider, and Apple Mail uses "Begin forwarded message:".
  return (
    /(^|[\s\]])(?:fw|fwd):/i.test(emailSubject) ||
    /-{2,}\s*Forwarded message\s*-{2,}/i.test(emailBody) ||
    /Begin forwarded message:/i.test(emailBody)
  );
};

export const shouldHideQuotedContent = ({
  body,
  showSignature,
  subject,
}: EmailQuoteVisibilityInput): boolean => !showSignature && !isForwardedEmail({ body, subject });
